export const getApiOrigin = () => {
  const { protocol } = window.location;
  const env = document.documentElement.dataset.vanEnv || process.env.CSC_DEV_ENV;
  const dict: { [key: string]: string } = {
    dev: 'llim-api-dev.xiaolachuxing.com',
    stg: 'llim-api-stg.xiaolachuxing.com',
    pre: 'llim-api-pre.xiaolachuxing.com',
    prod: 'llim-api.xiaolachuxing.com'
  };
  const apiHost = (env && dict[env]) ?? 'llim-api-stg.xiaolachuxing.com';
  return `${protocol}//${apiHost}`;
};

export const getSocketOrigin = () => {
  const env = document.documentElement.dataset.vanEnv || process.env.CSC_DEV_ENV;
  const dict: { [key: string]: string } = {
    dev: 'llim-dev.xiaolachuxing.com',
    stg: 'llim-stg.xiaolachuxing.com',
    pre: 'llim-pre.xiaolachuxing.com',
    prod: 'llim.xiaolachuxing.com'
  };

  const apiHost = (env && dict[env]) || 'llim-stg.xiaolachuxing.com';
  return `wss://${apiHost}`;
};

export const getAudioSocketOrigin = () => {
  const env = document.documentElement.dataset.vanEnv || process.env.CSC_DEV_ENV;
  const dict: { [key: string]: string } = {
    dev: 'ops-vms-ws-stg.huolala.cn',
    stg: 'ops-vms-ws-stg.huolala.cn',
    pre: 'ops-vms-ws-pre.huolala.cn',
    prod: 'ops-vms-ws.huolala.cn'
  };

  const apiHost = (env && dict[env]) || 'ops-vms-ws-stg.huolala.cn';
  return `wss://${apiHost}`;
};

export const getFbOrigin = () => {
  const env = document.documentElement.dataset.vanEnv || process.env.CSC_DEV_ENV;
  const dict: { [key: string]: string } = {
    dev: 'csc-fb-v-dev.xiaolachuxing.com',
    stg: 'csc-fb-v-stg.xiaolachuxing.com',
    pre: 'csc-fb-v-pre.xiaolachuxing.com',
    prod: 'csc-fb-v.xiaolachuxing.com'
  };
  const apiHost = (env && dict[env]) ?? 'csc-fb-v.xiaolachuxing.com';
  return `https://${apiHost}`;
};

export const getSensorOrigin = (project = 'xluser') => {
  const env = document.documentElement.dataset.vanEnv || process.env.CSC_DEV_ENV || 'dev';
  const dict: { [key: string]: string } = {
    dev: `uba-stg.xiaolachuxing.com/sa?project=${project}`,
    stg: `uba-stg.xiaolachuxing.com/sa?project=${project}`,
    pre: `uba-stg.xiaolachuxing.com/sa?project=${project}`,
    prod: `uba.xiaolachuxing.com/sa?project=${project}`
  };
  const apiHost = env && dict[env];
  return `https://${apiHost}`;
};

export const getEpLightOrigin = (stable?: string) => {
  const env = document.documentElement.dataset.vanEnv || process.env.CSC_DEV_ENV || 'dev';
  const dict: { [key: string]: string } = {
    dev: `ep-light-h5-v-stg.huolala.cn`,
    stg: `ep-light-h5--stable-1-v-stg.huolala.cn`,
    pre: `ep-light-h5--stable-1-v-pre.huolala.cn`,
    prod: `ep.huolala.cn`
  };
  const apiHost = (env && dict[env]).replace(
    '--stable-1',
    stable && Number.isInteger(Number(stable)) ? `--stable-${stable}` : ''
  );
  return `https://${apiHost}`;
};

export default getApiOrigin;
